import { useTranslation } from 'react-i18next';
import { RFQStatus } from '@steelbuy/ts-shared';
import { Dropdown, SelectOption } from '@steelbuy/ui-primitive';
import { useMyRFQsContext } from '../../components/my-rfqs/MyRFQsContext';

export const FILTER_CRITERIA_ID = 'filter';
export const FILTER_PROPERTY = 'status.value';

export const MyRequestQuotesFilter = () => {
    const { t } = useTranslation('translation');
    const { myRFQFilter, setMyRFQFilter } = useMyRFQsContext();

    const filterOptions: SelectOption[] = [RFQStatus.UNDER_REVIEW, RFQStatus.CLOSED].map((value) => ({
        label: t(`application.myQuotes.rfqStatus.${value}` as never),
        value,
    }));

    const handleFilterChange = (value: string[]) => {
        setMyRFQFilter(value as RFQStatus[]);
    };

    return (
        <Dropdown
            multiselect
            title={t('application.myRFQFilter.selectLabel')}
            options={filterOptions}
            preselection={myRFQFilter}
            onChange={handleFilterChange}
            placeholder={t('application.myRFQFilter.selectPlaceholder')}
        />
    );
};
